import {IComponentController, IScope} from "angular";
import {LqbFundedReportLog} from "../../model/LqbFundedReportLog";
import './FundedLoggingComponent.scss';

interface FundedLoggingComponentScope extends IScope {
    logs: LqbFundedReportLog[];
}

export class FundedLoggingComponent implements IComponentController {

    private logs: LqbFundedReportLog[];
    private $scope: FundedLoggingComponentScope;

    static instance = {
        template: require('./FundedLoggingComponent.html'),
        controller: ['$scope', FundedLoggingComponent],
        bindings: {
            logs: '<'
        }
    };

    constructor($scope: FundedLoggingComponentScope) {
        this.$scope = $scope;
    }

    $onInit(): void {
        this.$scope.logs = this.logs;
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        let changeObj = onChangesObj['logs'];
        if (changeObj && !changeObj.isFirstChange()) {
            this.$scope.logs = changeObj.currentValue;
        }
    }


}